import { render } from "./StructureView.vue?vue&type=template&id=6714d721&scoped=true"
import script from "./StructureView.vue?vue&type=script&lang=js"
export * from "./StructureView.vue?vue&type=script&lang=js"

import "./StructureView.vue?vue&type=style&index=0&id=6714d721&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6714d721"]])

export default __exports__